import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class AirChargeService {
  private airchargeServices: string[] = [
    'WE Air Charge',
    'Etisalat Air Charge',
    'Orange Air Charge',
    'Vodafone Air Charge',
    'Orange Recharge',
  ];
  public calculateServiceFees(serviceName: string): number {
    if (serviceName === 'WE Air Charge') return 0;
    if (serviceName === 'Etisalat Air Charge') return 0.4286;
    if (serviceName === 'Orange Air Charge') return 0.43;
    if (serviceName === 'Vodafone Air Charge') return 0.4286;
    if (serviceName === 'Orange Recharge') return 0.4286;
    else {
      return 0;
    }
  }
  public calculateTotalAmount(amount:number, serviceName:string) {
    const add = amount * this.calculateServiceFees(serviceName);
    return +amount + +add;
  }
  public isAirchargeService(service: string): boolean {
    return this.airchargeServices.includes(service);
  }
}
